// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useBurnRequests2Step } from './useBurnRequests2Step';
import { useExecutedBurns2Step } from './useExecutedBurns2Step';
import { useRejectedBurns2Step } from './useRejectedBurns2Step';

export const useGetBurnQueries = () => {
  const burnRequests2Step = useBurnRequests2Step();
  const executedBurns2Step = useExecutedBurns2Step();
  const rejectedBurns2Step = useRejectedBurns2Step();
  return {
    burnRequests2Step,
    executedBurns2Step,
    rejectedBurns2Step,
  };
};
